export enum Permission {
  ADD_TENANT = 'ADD_TENANT',
  ADD_ROUTE = 'ADD_ROUTE',
  ADD_COMPONENT = 'ADD_COMPONENT',
  ADD_SUBSCRIPTION = 'ADD_SUBSCRIPTION',
  DEPLOY_INGRESS_SERVICES = 'DEPLOY_INGRESS_SERVICES',
  ADD_SOLUTION = 'ADD_SOLUTION',
  ADD_SOLUTION_VERSION = 'ADD_SOLUTION_VERSION',
  ADD_LOB = 'ADD_LOB',
  EDIT_SOLUTION = 'EDIT_SOLUTION',
  DELETE_SOLUTION = 'DELETE_SOLUTION',
  EDIT_LOB = 'EDIT_LOB',
  DELETE_LOB = 'DELETE_LOB',
  EDIT_SOLUTION_VERSION = 'EDIT_SOLUTION_VERSION',
  DELETE_SOLUTION_VERSION = 'DELETE_SOLUTION_VERSION',
  CREATE_SANDBOX = 'CREATE_SANDBOX',

  DEPLOY_CONFIG_INSTANCE = 'DEPLOY_CONFIG_INSTANCE',
  UPDATE_CONFIG_INSTANCE = 'UPDATE_CONFIG_INSTANCE',
  TERMINATE_CONFIG_INSTANCE = 'TERMINATE_CONFIG_INSTANCE',

  TERMINATE_PTL_INSTANCE = 'TERMINATE_PTL_INSTANCE',
  DEPLOY_PTL_INSTANCE = 'DEPLOY_PTL_INSTANCE',
  UPDATE_PTL_INSTANCE = 'UPDATE_PTL_INSTANCE',
  UPDATE_SECRETS = 'UPDATE_SECRETS',

  EDIT_PTL_WORKFLOW = 'EDIT_PTL_WORKFLOW',
  DEFINE_PTL_WORKFLOW = 'DEFINE_PTL_WORKFLOW',

  CONFIGURE_SERVICE = 'CONFIGURE_SERVICE',
  PUBLISH_CONFIG_PACK = 'PUBLISH_CONFIG_PACK',

  UPLOAD_CRVT = 'UPLOAD_CRVT',

  CREATE_SERVICE_DEFINITION = 'CREATE_SERVICE_DEFINITION',
  DELETE_SERVICE_DEFINITION = 'DELETE_SERVICE_DEFINITION',
  UPDATE_SERVICE_DEFINITION = 'UPDATE_SERVICE_DEFINITION',

  VIEW_ENTERPRISE = 'VIEW_ENTERPRISE',
  VIEW_ENTERPRISE_PROSPECT = 'VIEW_ENTERPRISE_PROSPECT',
  VIEW_ENTERPRISE_SERVICE = 'VIEW_ENTERPRISE_SERVICE',
  UPGRADE_ENTERPRISE = 'UPGRADE_ENTERPRISE',

  VIEW_SETTINGS = 'VIEW_SETTINGS',
  DOWNLOAD_IAC = 'DOWNLOAD_IAC',

  SERVICES_SECTION= 'SERVICES_SECTION',
  RETRY = 'RETRY',
  NO_SERVICES = 'NO_SERVICES',
  SERVICE_DEF_MENU = 'INSTANCE_MENU',
  DR_ACTION = 'DR_ACTION',
  UPDATE_VERSION = 'UPDATE_VERSION',
  EXTERNAL_PACKAGE_UPDATE = 'EXTERNAL_PACKAGE_UPDATE',
  EDIT_EMAIL = 'EDIT_EMAIL',
  ADD_SSH_KEY = 'ADD_SSH_KEY'
}


export enum Permissions {
  SOLUTION_CREATE = '/solution/create',
  SOLUTION_READ = '/solution/read',
  SOLUTION_UPDATE = '/solution/update',
  SOLUTION_DELETE = '/solution/delete',
  TENANT_READ = '/tenant/read',
  TENANT_CREATE = '/tenant/create',
  TENANT_UPDATE = '/tenant/update',
  BLUEPRINT_READ = '/blueprint/read',
  BLUEPRINT_CREATE = '/blueprint/create',
  BLUEPRINT_UPDATE = '/blueprint/update',
  CONFIGURATION_READ = '/configuration/read',
  INSTANCE_DR = '/instance/dr',
  TENANT_ONBOARDING = '/tenant/onboarding',
  INSTANCE_UPDATE = '/instance/update',
  INSTANCE_READ = '/instance/read',
  INSTANCE_CONFIG = '/instance/config',
  INSTANCE_SFTP_CONFIG = '/instance/sftp/config',
  INSTANCE_REDEPLOY = '/instance/redeploy',
  INSTANCE_EXTEND = '/instance/extend',
  INSTANCE_START = '/instance/start',
  INSTANCE_STOP = '/instance/stop',
  INSTANCE_TEST = '/instance/test',
  INSTANCE_DELETE = '/instance/delete',
  BLUEPRINT_DELETE = '/blueprint/delete',
  INSTANCE_CREATE  = '/instance/create',
  INSTANCE_AGENT_MANAGE = '/instance/agent/manage',

  JUMPBOX_CREATE = '/tenant/jumpboxes/create',
  JUMPBOX_DELETE = '/tenant/jumpboxes/delete',
  JUMPBOX_READ = '/tenant/jumpboxes/read',
  JUMPBOX_UPDATE = '/tenant/jumpboxes/update',

  PRIVATE_EP_DELETE ='/tenant/pe-connections/delete',
  PRIVATE_EP_UPDATE ='/tenant/pe-connections/update',
  PRIVATE_EP_CREATE ='/tenant/pe-connections/create',
  PRIVATE_EP_READ ='/tenant/pe-connections/read',
  
  SCHEDULE_READ ='/schedule/read',
  SCHEDULE_CREATE ='/schedule/create',
  SCHEDULE_UPDATE ='/schedule/update',
  SCHEDULE_DELETE ='/schedule/delete',

  CUSTOMPACKAGE_READ = '/package-reference/read',
  CUSTOMPACKAGE_CREATE = '/package-reference/create',
  CUSTOMPACKAGE_DELETE = '/package-reference/delete',

  RUNBOOK_READ = '/env-scheduler/runbook/read',
  RUNBOOK_CREATE = '/env-scheduler/runbook/create',
  RUNBOOK_UPDATE = '/env-scheduler/runbook/update',
  RUNBOOK_DELETE = '/env-scheduler/runbook/delete',

  AWS_SCHEDULE_READ = "/env-scheduler/schedules/read",
  AWS_SCHEDULE_CREATE = "/env-scheduler/schedules/create",
  AWS_SCHEDULE_UPDATE = "/env-scheduler/schedules/update",
  AWS_SCHEDULE_DELETE = "/env-scheduler/schedules/delete",

  AUDIT_READ = '/audit/read',
  GROUP_READ = '/authz/group/read',
  GROUP_CREATE = '/authz/group/create',
  GROUP_UPDATE = '/authz/group/update',
  ROLE_READ = '/authz/role/read',
  ROLE_CREATE = '/authz/role/create',
  ROLE_UPDATE = '/authz/role/update',
  ROLE_ASSIGN_READ = '/authz/role-assignment/read',
  ROLE_ASSIGN_CREATE = '/authz/role-assignment/create',
  ROLE_ASSIGN_UPDATE = '/authz/role-assignment/update',

  LOCAL_CONFIG_APPLY = '/instance/local-configuration/apply',
  LOCAL_CONFIG_READ_RESULT = '/instance/local-configuration/result/read',
  LOCAL_CONFIG_READ = '/instance/local-configuration/read',

  SIZING_CREATE = '/instance/sizing/document/create',
  SIZING_READ = '/instance/sizing/document/read',
  SIZING_UPDATE = '/instance/sizing/document/update',
  SIZING_DELETE = '/instance/sizing/document/delete'

}

export enum Datazone {
  PII = 'pii',
  NONPII = 'nonpii',
  LIVE = 'prod'
}

export enum Types {
  TSI = 'tsi',
  TSS = 'tss',
  DEV = 'dev',
  PTL = 'ptl',
  LIVE = 'live',
  OTHERS = 'others'
}

export enum IDs {
  ID = 'id'
}


export enum Attributes {
  DATAZONE = 'datazone',
  TYPE = 'type',
  ID = 'id'
}


